<template>
  <div class="card-wrapper" v-if="imageUrl">
    <img
      :src="
        imageUrl.includes('http')
          ? imageUrl
          : require(`../../../assets/images/card-images/${imageUrl}`)
      "
      alt="this is card image"
      class="card-image"
    />
    <div
      v-if="!imageUrl.includes('http') && !hideContent"
      :style="{
        color: customFontColor || colorStyle,
        fontSize: contentSize + 'px',
      }"
      class="card-content title3"
    >
      {{ cardContent }}
    </div>
    <div
      v-if="variant === 'normal' && !imageUrl.includes('http')"
      class="card-value title3"
      :style="{ color: customFontColor || colorStyle }"
    >
      ${{ cardValue }}.00
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters } from "vuex";

export default {
  props: {
    imageUrl: {
      required: true,
      type: String,
      default: "",
    },
    cardContent: {
      required: true,
      type: String,
    },
    cardValue: {
      type: Number,
    },
    colorStyle: {
      required: true,
      type: String,
    },
    customColor: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
    },
    contentSize: {
      type: Number,
    },
    hideContent: {
      type: Boolean,
      default: false,
    },
    quantity: {
      type: Number,
      default: 1,
    },
    giftCardItem: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(["currentStoreDoc", "desktopStyles"]),
    customFontColor() {
      return this.currentStoreDoc ? this.currentStoreDoc.CustomFontColor : null;
    },
  },
  methods: {
    inc() {
      this.$store.commit("newGiftShoppingCart/UpdateGiftItemQuantity", {
        item: {
          ...this.giftCardItem,
        },
        quantity: this.quantity + 1,
      });
    },
    dec() {
      this.$store.commit("newGiftShoppingCart/UpdateGiftItemQuantity", {
        item: {
          ...this.giftCardItem,
        },
        quantity: this.quantity - 1,
      });
    },
  },
};
</script>

<style scoped>
.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5%;
}
.card-content {
  color: #ffffff;
  position: absolute;
  width: 80%;
  text-align: center;
  top: 54%;
  transform: translate(-50%, -50%);
  left: 50%;
  overflow-wrap: break-word;
  overflow: auto;
}
.card-value {
  color: #ffffff;
  position: absolute;
  top: 0.5rem;
  right: 1rem;
}
.card-wrapper {
  position: relative;
  /* width: 100%; */
  height: 100%;
}
.carousel__nav .card-wrapper {
  cursor: pointer;
}

.numbers-container {
  margin-bottom: -1rem;
}
</style>
